export const initState = {
  courseInfo: null,
  formData: null,
  formResults: null,
  reviewData: null,
  reservationPending: {}
};
